import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=36d40e36&"
import script from "./Master.vue?vue&type=script&lang=js&"
export * from "./Master.vue?vue&type=script&lang=js&"
import style0 from "./Master.vue?vue&type=style&index=0&id=36d40e36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports